import { render, staticRenderFns } from "./OwnersList.vue?vue&type=template&id=036d540f&"
import script from "./OwnersList.vue?vue&type=script&lang=js&"
export * from "./OwnersList.vue?vue&type=script&lang=js&"
import style0 from "./OwnersList.vue?vue&type=style&index=0&id=036d540f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports